const noop = v => v;

const getCumulated = (key, items, enhancer = noop) => {
  const value = items.reduce((acc, item) => acc + item[key], 0);
  return enhancer(value);
};

export default getCumulated;
